import BaseRepository from './base.repository';

// Allow the API's shared 60-second generation/translation budget plus storage and persistence.
const DIET_ANALYSIS_REQUEST_TIMEOUT_MS = 75000;

class NutritionRepository extends BaseRepository {
  constructor() {
    super('/food-diary');
  }

  getMeals(params) {
    return this.client.get('', params, { timeout: DIET_ANALYSIS_REQUEST_TIMEOUT_MS });
  }

  getMeal(mainUnique) {
    return this.client.get(`/${mainUnique}`, undefined, {
      timeout: DIET_ANALYSIS_REQUEST_TIMEOUT_MS,
    });
  }

  getLoggedDates(params) {
    return this.client.get('/logged-dates', params);
  }

  createMeal(payload) {
    return this.client.post('', payload, { timeout: DIET_ANALYSIS_REQUEST_TIMEOUT_MS });
  }

  updateMealTime(mainUnique, payload) {
    return this.client.patch(`/${mainUnique}/time`, payload, {
      timeout: DIET_ANALYSIS_REQUEST_TIMEOUT_MS,
    });
  }

  deleteMeal(mainUnique) {
    return this.client.delete(`/${mainUnique}`);
  }

  getWeeklySummary() {
    return this.client.get('/weekly-summaries', undefined, {
      timeout: DIET_ANALYSIS_REQUEST_TIMEOUT_MS,
    });
  }

  getWeeklyReport(mainUnique) {
    return this.client.get(`/weekly-summaries/${mainUnique}`, undefined, {
      timeout: DIET_ANALYSIS_REQUEST_TIMEOUT_MS,
    });
  }

  getWeeklyHistory(params) {
    return this.client.get('/weekly-summaries/history', params);
  }

  generateWeeklySummary() {
    return this.client.post('/weekly-summaries', undefined, {
      timeout: DIET_ANALYSIS_REQUEST_TIMEOUT_MS,
    });
  }
}

export default new NutritionRepository();
